import React from "react";
import { useSelector } from "react-redux";
import NavItem from "./NavItem";

function NavGroup({ item }) {
  const drawerOpen = useSelector((s) => s.menu.drawerOpen);

  return (
    <div style={styles.group}>
      {/* {drawerOpen && (
        <div style={{ ...styles.title, color: "rgba(255,255,255,0.8)" }}>{item.title}</div>
      )} */}
      {item.children?.map((child) => (
        <NavItem key={child.id} item={child} />
      ))}
    </div>
  );
}

const styles = {
  group: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  title: {
    fontSize: "0.65rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    padding: "16px 12px 6px",
  },
};

export default NavGroup;
